import { gradientsBar, moreBar, doubleBar, groupBar, pieBar, proportionBar } from './components';
export default {
  name: 'bar',
  components: {
    gradientsBar,
    moreBar,
    doubleBar,
    groupBar,
    pieBar,
    proportionBar
  },
  data() {
    return {};
  }
};